import script from "./GBPDescriptionFix.vue?vue&type=script&setup=true&lang=js"
export * from "./GBPDescriptionFix.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__